/**
 * Who is tracking this opportunity (persisted as data.assigned_by).
 */

import React from 'react';
import { User } from 'lucide-react';

export function TrackingOwnerChip({
  name,
  trackingStatus,
}: {
  name?: string | null;
  trackingStatus?: string | null;
}) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  const tracked = typeof trackingStatus === 'string' && trackingStatus.trim().length > 0;
  if (!trimmed && !tracked) return null;

  const title = trimmed ? `Tracked by ${trimmed}` : 'Tracked';

  return (
    <div
      className="inline-flex items-center gap-1 w-fit rounded-full border border-slate-200 bg-slate-100 px-2 py-1 text-xs text-slate-700 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200"
      title={title}
    >
      <User className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span>
        {trimmed ? (
          <>
            Tracked by <span className="font-semibold">{trimmed}</span>
          </>
        ) : (
          'Tracked'
        )}
      </span>
    </div>
  );
}
